import { jsx } from "react/jsx-runtime";
import {
  createContext,
  useState,
  useContext,
  useMemo
} from "react";
const AdjustmentsContext = createContext(
  void 0
);
const AdjustmentsProvider = ({
  children
}) => {
  const [hasPendingAdjustments, setHasPendingAdjustments] = useState(false);
  const value = useMemo(
    () => ({ hasPendingAdjustments, setHasPendingAdjustments }),
    [hasPendingAdjustments, setHasPendingAdjustments]
  );
  return /* @__PURE__ */ jsx(AdjustmentsContext.Provider, { value, children });
};
const useAdjustments = () => {
  const context = useContext(AdjustmentsContext);
  if (context === void 0) {
    throw new Error(
      "useAdjustments must be used within an AdjustmentsProvider"
    );
  }
  return context;
};
export {
  AdjustmentsProvider,
  useAdjustments
};
